import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import * as XLSX from 'xlsx';
import { ToolbarModule } from 'primeng/toolbar';
import { InputNumberModule } from 'primeng/inputnumber';
import {
  ConfirmationService,
  LazyLoadEvent,
  MessageService,
} from 'primeng/api';
import { ContractCalculationService } from '../contract-calculation.service';
import { HttpParams } from '@angular/common/http';
import { delay, forkJoin, Subscription } from 'rxjs';

import { Customer } from '../../master-data/customers/customers.model';
import { CustomersService } from '../../master-data/customers/customers.service';
import { Business } from '../../master-data/business/business.model';
import { BusinessService } from '../../master-data/business/business.service';

import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ChipModule } from 'primeng/chip';
import { DropdownModule } from 'primeng/dropdown';
import { IftaLabelModule } from 'primeng/iftalabel';
import { Supplier } from '../../master-data/suppliers/suppliers.model';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ContractCalculation } from '../contract-calculation.model';
import { DatePicker } from 'primeng/datepicker';
import { FloatLabel } from 'primeng/floatlabel';
import { SuppliersService } from '../../master-data/suppliers/suppliers.service';
import { ProcessStatus } from '../../enums/processStatus';
import { ProgressSpinner } from 'primeng/progressspinner';
import { AiStudioComponent } from '../../ai-studio/ai-studio.component';
import { ContractType } from '../../contract/contract-types';
import { Dialog } from 'primeng/dialog';
import {
  documentCategory,
  intendedUse,
  ListOfValuesService,
} from '../../listofvalues/list-of-values.service';
import { AppUser } from '../../users/user.model';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthorizationService } from '../../services/authorization.service';

@Component({
  selector: 'app-contract-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    CalendarModule,
    TagModule,
    ToastModule,
    ToolbarModule,
    InputNumberModule,
    InputGroupModule,
    InputGroupAddonModule,
    ChipModule,
    DropdownModule,
    IftaLabelModule,
    ConfirmDialog,
    DatePicker,
    ProgressSpinner,
    Dialog,
  ],

  providers: [MessageService, ConfirmationService],
  templateUrl: './contract-calculation-list.component.html',
  styleUrls: ['./contract-calculation-list.component.css'],
})
export class ContractCalculationListComponent implements OnInit {
  @ViewChild('dt') dt!: Table;
  contractCalculations: ContractCalculation[] = [];
  totalRecords = 0;
  page: number = 0;
  rows: number = 25;
  submitted: boolean = false;
  isLoading: boolean = false;
  showPopup: boolean = false;
  extraForm!: FormGroup;
  
  filterForm!: FormGroup;
  
  private filterSub!: Subscription;

  // Inline editing state for rebate amount
  currentUser?: AppUser | null = null;
  rebateAmountEdits: Record<number, number> = {};
  savingRebate: Record<number, boolean> = {};

  CustomerfilterValue: string = '';
  BusinessfilterValue: string = '';
  SupplierfilterValue: string = '';

  CanGenerateResult: boolean = false;
  private authSubscription: Subscription | undefined;  

  contractTypes: { label: string; value: string }[] = Object.entries(
    ContractType
  ).map(([key, value]) => ({
    label: value,
    value: key,
  }));

  processStatus: { label: string; value: string }[] = Object.keys(ProcessStatus)
    .filter((t) =>
      ['NEW', 'INPROGRESS', 'COMPLETED', 'ERROR'].includes(t.toString())
    ) // بس دول
    .map((t) => ({
      label: t.toString(),
      value: t.toString().toUpperCase(),
    }));

  // Options for filter dropdowns
  customers: Customer[] = [];
  filteredCustomers: Customer[] = [];
  businesses: Business[] = [];
  filteredBusinesses: Business[] = [];
  suppliers: Supplier[] = [];
  filteredSuppliers: Supplier[] = [];

  params: HttpParams = new HttpParams();
  listCount: number = 0;
  constructor(
    private aiStudioComponent: AiStudioComponent,
    private contractCalculationService: ContractCalculationService,
    private messageService: MessageService,
    private customerService: CustomersService,
    private businessService: BusinessService,
    private supplierService: SuppliersService,
    private authService: AuthenticationService,
    private authorizationService: AuthorizationService,
    private fb: FormBuilder,
    private router: Router,  ) {}

  ngOnInit() {
   // Load current user from session for permission checks
      this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
    this.buildFilterForm();
    this.buildExtraForm();
    this.loadDropdownData();
    this.checkPermissions();
  }
   private checkPermissions(): void {
    this.authSubscription = this.authService.currentUser$.subscribe((user) => {
      if (user) {
        this.CanGenerateResult = this.authorizationService.hasPermission(
          user,
          'Rebate Results',
          ['update']
        );
       
      } else {
        this.CanGenerateResult = false;
      }
    });
  }

  buildFilterForm() {
    this.filterForm = this.fb.group({
      arStatus: [null],
      startDate: [null],
      endDate: [null],
      customer: [null],
      business: [null],
      supplier: [null],
      contractType: [null],
      rebateTrxNumber: [null],
      refInvoice: [null],
      rebateTrxStartDate: [null],
      rebateTrxEndDate: [null],
    });
  }
  buildExtraForm() {
    this.extraForm = this.fb.group({
      trxDate: [null],
    });
  }

  loadContractCalculations(
    event?: TableLazyLoadEvent,
    isExport = false,
    callback?: (contracts: ContractCalculation[]) => void
  ): void {
    if (this.params.keys().length > 0) {
      this.isLoading = true;
      if (isExport) {
        this.params = this.params.set('page', 0);
        this.params = this.params.set('size', 200000);
      } else {
        this.params = this.params.set(
          'page',
          event?.first
            ? (event.first / (event.rows || this.rows)).toString()
            : this.page.toString()
        );
        this.params = this.params.set(
          'size',
          event?.rows ? event.rows.toString() : this.rows.toString()
        );

        if (event?.sortField) {
          this.params = this.params.set(
            'sort',
            `${event.sortField},${event.sortOrder === 1 ? 'asc' : 'desc'}`
          );
        } else {
          this.params = this.params.set('sort', 'lineId,desc');
        }
      }

      this.contractCalculationService
        .searchContractCalculations(this.params)
        .subscribe({
          next: (resp) => {
            const linesPage = resp?.lines;
            this.contractCalculations = (linesPage?.content || []).map((c: any) => ({
              ...c,
              // Normalize possible array-based timestamps to Date
              rebateUpdatedAt: this.toDateFromArray(c?.rebateUpdatedAt) ?? c?.rebateUpdatedAt,
              claimUpdatedAt: this.toDateFromArray(c?.claimUpdatedAt) ?? c?.claimUpdatedAt,
            }));
            this.totalRecords = linesPage?.totalElements ?? 0;
            this.isLoading = false;
            if (callback) {
              callback(this.contractCalculations);
            }
          },
          error: (error) => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to load contract Calculations',
            });
          },
        });
    }
  }

  isInvalid(controlName: string): boolean {
    const control = this.filterForm.get(controlName);
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || this.submitted)
    );
  }
  hasNewStatus(): boolean {
    let allNew = false;
    this.listCount = 0;
    if (this.filterForm.controls?.['arStatus']?.value === 'NEW' || this.filterForm.controls?.['arStatus']?.value === 'ERROR' ) {
      if (this.contractCalculations.length === 0) {
        return false;
      }
      allNew =
        this.contractCalculations.length > 0
          ? this.contractCalculations.every(
              (item) => item.arStatus === 'NEW' || item.arStatus === 'ERROR'
            )
          : false;

      if (allNew == true) {
        this.listCount = this.totalRecords;
      } else {
        this.listCount = 0;
      }
    } else {
      this.listCount = 0;
    }

    return allNew;
  }

  submitForm(type: String) {
    this.submitted = true;
    const filterFormClone = this.filterForm.value;
    // if (this.filterForm.valid) {
    this.isLoading = true;

    const filters: any = {
      arStatus: filterFormClone.arStatus,
      customerNumber: filterFormClone.customer?.customerNumber,
      businessNumber: filterFormClone.business?.businessCode,
      supplier: filterFormClone.supplier?.supplierNumber,
      startDate: filterFormClone.startDate
        ? this.formatToLocalDateTime(filterFormClone.startDate)
        : null,
      endDate: filterFormClone.endDate
        ? this.formatToLocalDateTime(filterFormClone.endDate, true)
        : null,
      contractType: filterFormClone.contractType || null,
      rebateTrxNumber: filterFormClone.rebateTrxNumber || null,
      refInvoice: filterFormClone.refInvoice || null,

      rebateTrxStartDate: filterFormClone.rebateTrxStartDate
        ? this.formatToLocalDateTime(filterFormClone.rebateTrxStartDate)
        : null,
      rebateTrxEndDate: filterFormClone.rebateTrxEndDate
        ? this.formatToLocalDateTime(filterFormClone.rebateTrxEndDate, true)
        : null,
        
    };

    let method;
    if (type === 'generate') {
      this.showPopup = true;
      const extraFormClone = this.extraForm?.value;
      const extraData: any = {
        trxDate: extraFormClone?.trxDate
          ? this.formatToLocalDateTime(extraFormClone.trxDate)
          : null,
      };
      Object.keys(extraData).forEach((key) => {
        const value = extraData[key];
        if (value === null || value === '' || value === undefined) {
          delete extraData[key];
        }
      });

      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value !== null && value !== '' && value !== undefined) {
          filters[key] = value.toString();
        } else {
          delete filters[key];
        }
      });

      method = this.contractCalculationService
        .generateContractCalculation(filters, extraData)
        .subscribe({
          next: (data) => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Contract calculations generated successfully.',
            });
            setTimeout(() => {
              this.reloadPage();
            }, 2000);
          },
          error: (err) => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to generate calculations.',
            });
          },
        });
    } else if (type === 'search') {
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value !== null && value !== '' && value !== undefined) {
          this.params = this.params.set(key, value);
        } else {
          this.params = this.params.delete(key);
        }
      });
      this.dt.reset();
    }
    // } else {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error',
    //     detail: 'Please Fill required fields.',
    //   });
    // }
  }
  togglePopup(status: boolean): void {
    this.showPopup = status;
  }



  loadDropdownData(): void {
    forkJoin({
      customers: this.customerService.getAllCustomers({ page: 0, size: 10000 }),
      businesses: this.businessService.getAllBusinesss({
        page: 0,
        size: 10000,
        loadSuppliers: true,
      }),
      suppliers: this.supplierService.getAllSuppliers({ page: 0, size: 10000 }),
    }).subscribe({
      next: (data) => {
        this.customers = data.customers.content;
        this.filteredCustomers = this.customers;
        this.businesses = data.businesses.content;
        this.filteredBusinesses = this.businesses;
        this.suppliers = data.suppliers.content;
        this.filteredSuppliers = this.suppliers;

      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load filter options.',
        });
        console.error('Error loading dropdown data:', err);
      },
    });
  }

  filterCustomers(event: any) {
    this.CustomerfilterValue = event.target.value;
    if (!event.target.value || event.target.value.length === 0) {
      this.filteredCustomers = this.customers;
    } else {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.customerName
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          customer.customerNumber
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
      );
    }
  }

  filterBusinesses(event: any) {
    this.BusinessfilterValue = event.target.value;
    if (!event.target.value || event.target.value.length === 0) {
      this.filteredBusinesses = this.businesses;
    } else {
      this.filteredBusinesses = this.businesses.filter(
        (business) =>
          business.businessName
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          business.businessCode
            ?.toLowerCase()
            .includes(event.target.value.toLowerCase())
      );
    }
  }

  filterSuppliers(event: any) {
    this.SupplierfilterValue = event.target.value;
    if (!event.target.value || event.target.value.length === 0) {
      this.filteredSuppliers = this.suppliers;
    } else {
      this.filteredSuppliers = this.suppliers.filter(
        (supplier) =>
          supplier.supplierName
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          supplier.supplierNumber
            ?.toLowerCase()
            .includes(event.target.value.toLowerCase())
      );
    }
  }

  onLazyLoad(event: any) {
    this.loadContractCalculations(event, false);
  }

  formatToLocalDateTime(date: Date, endOfDay = false): string {
    if (!date) return '';

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    // const hours = endOfDay ? 23 : 0;
    // const minutes = endOfDay ? 59 : 0;
    // const seconds = endOfDay ? 59 : 0;

    return `${year}-${month}-${day}`;
    // T${String(hours).padStart(2, '0')}:${String(
    //   minutes
    // ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  // UI permission to edit rebate (align with claim-calculation list)
  canEditRebate(row: ContractCalculation): boolean {
    return row?.arStatus === 'NEW' && !!this.currentUser?.canChangeRebate;
  }

  // Save edited rebate amount
  saveRebateAmount(row: ContractCalculation): void {
    const lineId = row.lineId;
    if (lineId == null) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Missing line ID for this row.',
      });
      return;
    }

    let newAmount = this.rebateAmountEdits[lineId] ?? row.rebateAmount;
    if (newAmount == null || isNaN(Number(newAmount))) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Change',
        detail: 'Please enter a valid rebate amount.',
      });
      return;
    }

    // No clamping: allow negative and up to two fraction digits (handled by input)
    newAmount = Number(newAmount);
    this.rebateAmountEdits[lineId] = newAmount;

    this.savingRebate[lineId] = true;
    this.contractCalculationService
      .updateRebateAmount(lineId, Number(newAmount))
      .subscribe({
        next: (updated) => {
          row.rebateAmount = updated?.rebateAmount ?? Number(newAmount);
          this.messageService.add({
            severity: 'success',
            summary: 'Saved',
            detail: 'Rebate amount updated',
          });
          this.savingRebate[lineId] = false;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update rebate amount.',
          });
          this.savingRebate[lineId] = false;
        },
      });
  }

  // Handle input change without clamping
  onRebateAmountChange(lineId: number | null | undefined, value: any): void {
    if (lineId == null) return;
    const numeric = Number(value);
    if (isNaN(numeric)) return;
    this.rebateAmountEdits[lineId] = numeric;
  }

  exportExcel() {
    this.loadContractCalculations(
      undefined,
      true,
      (contractCalculations: ContractCalculation[]) => {
        const dataToExport = contractCalculations.map((contractCalc) => ({
          'Vendor Number': contractCalc.vendorNumber,
          'Business Name': contractCalc.businessName,
          'Business': contractCalc.businessNumber,
          'AR Status': contractCalc.arStatus,
          'Source': contractCalc.source,
          'Type': contractCalc.type,
          'Period': contractCalc.period,
          'Line ID': contractCalc.lineId,
          'Contract Number': contractCalc.contractNo,
          'Customer ID': contractCalc.customerId,
          'Customer Number': contractCalc.customerNumber,
          'Customer Name': contractCalc.customerName,
          'Bill To': contractCalc.billTo,
          'Vendor Site Number': contractCalc.vendorSiteNumber,
          'Ledger ID': contractCalc.ledgerId,
          'Division': contractCalc.division,
          'Entity': contractCalc.entity,
          'Organization ID': contractCalc.orgId,
          'Claim Status': contractCalc.claimStatus,
          'Integration Status': contractCalc.integrationStatus,
          'Reference Customer Transaction ID': contractCalc.refCustomerTrxId,
          'Reference Customer Transaction Line ID': contractCalc.refCustomerTrxLineId,
          'Site Number': contractCalc.siteNumber,
          'Site Name': contractCalc.siteName,
          'Address 2': contractCalc.address1,
          'Address 3': contractCalc.address2,
          'Area': contractCalc.area,
          'City': contractCalc.city,
          'Reference Invoice': contractCalc.refInvoice,
          'Reference Invoice Date': contractCalc.refInvDate ? this.formatToLocalDateTime(contractCalc.refInvDate) : '',
          'Item Code': contractCalc.itemCode,
          'Vendor Catalog': contractCalc.vendorCatalog,
          'Item Description': contractCalc.itemDesc,
          'Unit Standard Price': contractCalc.unitStandardPrice,
          'Unit Price': contractCalc.unitePrice,
          'Invoice Quantity': contractCalc.invQty,
          'Invoice Amount': contractCalc.invAmount,
          'Rebate Transaction Number': contractCalc.rebateTrxNumber,
          'Rebate Transaction Date': contractCalc.rebateTrxDate ? this.formatToLocalDateTime(contractCalc.rebateTrxDate) : '',
          'Rebate Percent': contractCalc.rebatePercent,
          'Rebate Amount': contractCalc.rebateAmount,
          'Claim Percent': contractCalc.claimPercent,
          'Claim Amount': contractCalc.claimAmt,
          'Claim VAT': contractCalc.claimVat,
          'Claim Batch ID': contractCalc.claimBatchId,
          'Claim Number': contractCalc.claimNumber,
          'ERP AP Transaction ID': contractCalc.erpApTrxId,
          'ERP AP Transaction Number': contractCalc.erpApTrxNo,
          'ERP AP Transaction Date': contractCalc.erpApTrxDate,
          'AR GL Segments':
            contractCalc.arGlSegment1 +
            '-' +contractCalc.arGlSegment2 +
            '-' +contractCalc.arGlSegment3 +
            '-' +contractCalc.arGlSegment4 +
            '-' +contractCalc.arGlSegment5 +
            '-' +contractCalc.arGlSegment6 +
            '-' +contractCalc.arGlSegment7 +
            '-' +contractCalc.arGlSegment8 +
            '-' +contractCalc.arGlSegment9 +
            '-' +contractCalc.arGlSegment10,
        }));
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Contracts');
        XLSX.writeFile(wb, 'rebate_result_Export.xlsx');
      }
    );
  }

  reloadPage() {
    this.aiStudioComponent.reloadPage();
  }

  // Convert [yyyy, mm, dd, HH, mm, ss, nano] to Date
  private toDateFromArray(raw: any): Date | null {
    if (!raw) return null;
    if (raw instanceof Date) return raw as Date;
    if (Array.isArray(raw) && raw.length >= 6) {
      const [y, m, d, hh, mm, ss, nano] = raw;
      const ms = typeof nano === 'number' ? Math.floor(nano / 1_000_000) : 0;
      const date = new Date(y, (m ?? 1) - 1, d ?? 1, hh ?? 0, mm ?? 0, ss ?? 0, ms);
      return isNaN(date.getTime()) ? null : date;
    }
    // Try ISO string
    if (typeof raw === 'string') {
      const date = new Date(raw);
      return isNaN(date.getTime()) ? null : date;
    }
    return null;
  }
}
